import { AgGridReact } from 'ag-grid-react';
import { useState, useEffect } from 'react';
import moment from 'moment'
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import styled from 'styled-components';
import Conditions from '../../../StudyList/CellRenderers/Conditions'
import Checkbox from '../../../StudyList/CellRenderers/Checkbox'
import StudyLink from '../../../StudyList/CellRenderers/StudyLink'
import CTGStudy from '../../../StudyList/CellRenderers/CTGStudy'
import TotalRow from '../../../../components/Grid/CellRenderer/TotalRow';
import OverrideField from '../../../../helpers/OverrideField'
import LoadRowsComponent from '../../../../helpers/LoadRowsComponent';
import { excelStyles } from '../../../../components/Grid/ExcelStyles/excelStyles';
import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID);

const RecentStudies = ({ data }) => {
  const [gridApi, setGridApi] = useState(null);
  const gridOptions = {
    columnDefs: [
      {
        headerName: 'Visible',
        field: 'published',
        width: 60,
        cellRenderer: "checkbox",
        cellRendererParams: {
          source: "published",
        },
      },
      {
        headerName: 'Featured',
        field: 'featured',
        width: 60,
        cellRenderer: "checkbox",
        cellRendererParams: {
          source: "featured",
        },
      },
      {
        headerName: 'CTG Study',
        field: 'ctg_data',
        cellRenderer: 'isCTGStudy',
        width: 40,
      },
      {
        headerName: 'Org ID',
        field: 'org_study_id',
        cellRenderer: "studyLink",
        flex: '1'
      },
     
      {
        headerName: 'Conditions',
        field: "conditions",
        cellRenderer: "conditions",
        flex: '1'
      },
      // {
      //   headerName: 'Brief Title',
      //   field: 'connex_data.brief_title',
      //   cellRenderer: "overrideField",
      //   cellRendererParams: {
      //     source: "brief_title",
      //   },
      //   flex: '1'
      // },
      {
        headerName: 'NCT ID ',
        field: 'ctg_data.id_info.nct_id',
        cellRenderer: "overrideField",
        cellRendererParams: {
          source: "nct_id",
        },
        flex: '1'
      },
      // {
      //   headerName: 'Recruitment Status',
      //   field: 'connex_data.overall_status',
      //   cellRenderer: "overrideField",
      //   cellRendererParams: {
      //     source: "overall_status",
      //   },
      //   flex: '1'
      // },
      {
        headerName: 'Updated at',
        cellRenderer: "updatedTime",
        field: "updated_at",
        flex: '1'
      },
      {
        headerName: "",
        width: 40,
        cellRenderer: "removeRow",
      }
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      enablePivot: true,
      enableCharts: false,
      enableRowGroup: true,
      filterParams: {
        clearButton: true
      },
      cellStyle: { "white-space": "normal !important" },
      autoHeight: true,
      cellClassRules: {
        oddBackground: function (params) {
          return params.rowIndex % 2 == 0;
        },
      },
    },
    icons: {
      list: '<i className="fal fa-list"></i>'
    },
    columnTypes:{
      date: {
        filter: 'agDateColumnFilter',
        filterParams: {
          resetButton: true,
          comparator: function(filterLocalDateAtMidnight, cellValue) {
            let cellDate = null;
            let dateAsString = "";
            dateAsString = cellValue;
            if (dateAsString === null) {
              return 0;
            }
            cellDate = moment(dateAsString).toDate();
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          }
        }
      }
    },
    excelStyles,
    frameworkComponents: {
      checkbox: Checkbox,
      conditions: Conditions,
      studyLink: StudyLink,
      overrideField: OverrideField,
      // removeRow: ({ data }) => {
      //   // const { id, org_study_id } = data;
      //   const id = data?.id;
      //   const org_study_id = data?.org_study_id;
      //   return (
      //     <i
      //       className="fal fa-trash-alt"
      //       style={{ color: "red" }}
      //       onClick={() => deleteRow({id: id, org_study_id: org_study_id})}
      //     ></i>
      //   );
      // },
      LoadRowsComponent: LoadRowsComponent,
      isCTGStudy: CTGStudy,
      updatedTime: ({ data }) => {
        const updated_at = data?.updated_at;
        return (
          <span>{ updated_at && moment(updated_at).format("DD-MMM-YYYY, HH:mm")}</span>
        );
      },  
    },
    loadingCellRenderer: 'LoadRowsComponent',
    loadingCellRendererParams :{
      loadingMessage: 'One moment please...',
    },
  }
  // const cellClicked = (event) => {
  //   const { cellRenderer } = event.colDef;
  //   if (cellRenderer !== "removeRow") {
  //     onRowClicked(event.data);
  //   }
  // };
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  return(
    <AgGridContainer className="ag-theme-balham">
    <AgGridReact
    onGridReady={onGridReady}
    gridOptions={gridOptions}
    // onCellClicked={event => cellClicked(event)}
    rowData={data}
  ></AgGridReact>
  </AgGridContainer>
  )
}
export default RecentStudies


const AgGridContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: 2em;
`